import { Fragment } from 'react';
import { Formprops } from './Signup.types';
import Spinner from '../../../components/Spinner/Spinner';
import PasswordInput from '../../../components/Form/PasswordInput';
import { Link, useLocation } from 'react-router-dom';
import { getReturnUrlFromSearch, withReturnUrl } from '../../../utils/returnUrl';

const SignupForm = ({ register, formState: { errors, isSubmitting } }: Formprops) => {
  const { search } = useLocation();
  const loginHref = withReturnUrl('/login', getReturnUrlFromSearch(search));

  return (
    <Fragment>
      <label className="form-label" htmlFor="name">
        Nombres
      </label>
      <input
        className={`form-input${errors.name ? ' form-input-invalid' : ''}`}
        placeholder="Ej: Laura, Daniel"
        type="text"
        id="name"
        autoComplete="given-name"
        aria-invalid={Boolean(errors.name)}
        aria-describedby={errors.name ? 'signup-name-error' : undefined}
        {...register('name', { required: { value: true, message: 'Este campo es requerido' } })}
      />
      <p className="form-input-error-message" id="signup-name-error">{errors.name?.message}</p>
      <label className="form-label" htmlFor="lastName">
        Apellidos
      </label>
      <input
        className={`form-input${errors.lastName ? ' form-input-invalid' : ''}`}
        placeholder="Ej: Perez, Hernandez"
        type="text"
        id="lastName"
        autoComplete="family-name"
        aria-invalid={Boolean(errors.lastName)}
        aria-describedby={errors.lastName ? 'signup-lastname-error' : undefined}
        {...register('lastName', { required: { value: true, message: 'Este campo es requerido' } })}
      />
      <p className="form-input-error-message" id="signup-lastname-error">{errors.lastName?.message}</p>
      <label className="form-label" htmlFor="username">
        Usuario de MARES
      </label>
      <input
        className={`form-input${errors.username ? ' form-input-invalid' : ''}`}
        placeholder="Ej: laura.perez110, daniel.hernandez11"
        type="text"
        id="username"
        autoComplete="username"
        aria-invalid={Boolean(errors.username)}
        aria-describedby={errors.username ? 'signup-username-error' : undefined}
        {...register('username', {
          required: { value: true, message: 'Este campo es requerido' },
          pattern: {
            value: /([\w\d]{1,15}[.][\w\d]{1,15})\w+(?:(?!@))*$/,
            message: 'Ingrese un usuario válido',
          },
        })}
      />
      <p className="form-input-error-message" id="signup-username-error">{errors.username?.message}</p>
      <label className="form-label" htmlFor="password">
        Contraseña
      </label>
      <PasswordInput
        className={`form-input${errors.password ? ' form-input-invalid' : ''}`}
        placeholder="••••••••"
        id="password"
        autoComplete="new-password"
        aria-invalid={Boolean(errors.password)}
        aria-describedby={errors.password ? 'signup-password-error' : undefined}
        {...register('password', { required: { value: true, message: 'Este campo es requerido' } })}
      />
      <p className="form-input-error-message" id="signup-password-error">{errors.password?.message}</p>
      <label className="form-label" htmlFor="id">
        Número de documento
      </label>
      <input
        className={`form-input${errors.id ? ' form-input-invalid' : ''}`}
        placeholder="Ej: 13213122"
        type="text"
        id="id"
        inputMode="numeric"
        autoComplete="off"
        aria-invalid={Boolean(errors.id)}
        aria-describedby={errors.id ? 'signup-id-error' : undefined}
        {...register('id', { required: { value: true, message: 'Este campo es requerido' } })}
      />
      <p className="form-input-error-message" id="signup-id-error">{errors.id?.message}</p>
      <button className="form-button" type="submit" disabled={isSubmitting} aria-busy={isSubmitting}>
        {isSubmitting ? <><Spinner label="Creando cuenta" /><span>Creando cuenta…</span></> : 'Registrarse'}
      </button>
      <p className="form-note">¿Ya tienes una cuenta? <Link to={loginHref} className="form-link">Inicia sesión</Link></p>
    </Fragment>
  );
};

export default SignupForm;
